import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { renderActions, selectSavedCameraPositions, selectViewMode } from "features/render";
import { ViewMode } from "types/misc";

export function useStepBack() {
    const savedCameraPositions = useAppSelector(selectSavedCameraPositions);
    const viewMode = useAppSelector(selectViewMode);
    const canStepBack = savedCameraPositions.currentIndex >= 1 && viewMode !== ViewMode.Panorama;
    const dispatch = useAppDispatch();

    const stepBack = useCallback(() => {
        const step = savedCameraPositions.positions[savedCameraPositions.currentIndex - 1];

        if (!step) {
            return;
        }

        dispatch(renderActions.undoCameraPosition());
    }, [dispatch, savedCameraPositions]);

    return { stepBack, canStepBack };
}
